var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.09503C11.5361 1.03062 11.0683 0.998876 10.6 1.00003C5.298 1.00003 1 5.03003 1 10C1 14.97 5.298 19 10.6 19C11.076 19 11.5427 18.9684 12 18.905M19 10H9M19 10C19 9.30003 17.006 7.99203 16.5 7.50003M19 10C19 10.7 17.006 12.008 16.5 12.5",
    stroke: "#2B3674",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f35075f31efb7b9eb39d3eb88ad30d5d.svg";
export { ForwardRef as ReactComponent };